<a [href]="buttonData.buttonUrl" [target]="buttonData.openInNewTab ? '_blank' : '_self'"
  [rel]="buttonData.openInNewTab ? 'noopener noreferrer' : ''"
  class="button__container fw-bold d-flex justify-content-center align-items-center"
  [class.bg-secondary]="!buttonData.buttonType" [class.text-white]="!buttonData.buttonType"
  [class.text-decoration-none]="!buttonData.buttonType"
  [class.bg-transparent]="buttonData.buttonType?.includes('transparent')"
  [class.ps-0]="buttonData.buttonType?.includes('transparent')"
  [class.text-primary]="buttonData.buttonType?.includes('purple')" (click)="onClick($event)">
  <span class="button__label">{{ buttonData.buttonLabel }}</span>
  @if (buttonData.buttonIcon) {
  <span class="button__icon" [ngClass]="buttonData.buttonIcon"></span>
  }
</a>